import React from "react";
import { makeStyles } from "@mui/styles";
import ArtistSubmissionButton from "../Buttons/ArtistSubmission";
import Link from "next/link";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { callNow, enquireNow, share } from "../../util/common";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    fontFamily: "'Inter', sans-serif",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    background: "#110D20",
    flexDirection: "column-reverse ",
    padding: "0",
    color: "white",
    height: "96px",
    fontSize: "16px",
    fontWeight: "500",
    paddingBottom: "30px",
    "@media(max-width:480px)": {},
  },
  artistForm: {
    width: "55%",
    display: "flex",
    justifyContent: "center",
    // height: "300px",
  },
  companyName: {
    fontSize: "12px",
    position: "relative",
    display: "block",
    width: "100%",
    textAlign: "center",
    "&:before": {
      content: "''",
      position: "relative",
      display: "block",
      height: "1px",
      background: "#fff",
      opacity: "0.2",
      margin: "12px 20px",
      "@media(max-width:480px)": {},
    },
  },
  group: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    "@media(max-width:480px)": {
      position: "relative",
      width: "100%",
      marginLeft: "0",
      // justifyContent: "space-between",
      fontSize: "12px",
      fontWeight: "500",
      padding: "0 30px",
    },
  },
  tab: {
    margin: "0 20px",
    cursor: "pointer",
  },
  whatsApp: {
    position: "fixed",
    right: "25px",
    bottom: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    padding: "10px 15px",
    border: "1px solid rgba(255,255,255,0.4)",
    borderRadius: "10px",
    background: "#1e1b3d",
    cursor: "pointer",
    zIndex: "100",
    textDecoration: "none",
    "& img": {
      marginRight: "12px",
      width: "35px",
      height: "35px",
    },
    "@media(max-width:767px)": {
      padding: "0",
      border: "none",
      "& span": {
        display: "none",
      },
      "& img": {
        width: "35px",
        height: "35px",
      },
    },
  },
}));

export default function Footer() {
  const classes = useStyles();

  // const share = () => {
  //     const url = 'https://wa.me/+919999131131/?text=Hi.'
  //     const newWin = window.open(
  //       url,
  //       '_blank'
  //     )
  //     if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
  //       return false
  //     }
  //     return true
  // }
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <div className={`${classes.root} footer_main`}>
      <div style={{ width: "100%" }}>
        <div className={`${classes.group} group`}>
          <div className={`${classes.tab} tab`}>
            <span
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.open(
                  "https://fantiger.notion.site/FanTiger-Buy-and-Sell-Music-NFTs-df0b3c1285ca4ee4b2bf7df19643e54f",
                  "_blank"
                )
              }
            >
              Jobs
            </span>
          </div>
          <div className={`${classes.tab} tab`}>
            <span
              // style={{ cursor: "pointer"}}
              onClick={() => window.location.replace("/#Faqs")}
            >
              <a>FAQ</a>
            </span>
          </div>
          <div className={`${classes.tab} tab`}>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => window.open("/privacy", "_blank")}
            >
              Privacy
            </span>
          </div>
          {/* <div className={`${classes.tab} tab`}>
            <Link href="/artistsubmission">
              <a>Artist</a>
            </Link>
          </div> */}
          {/* <div className={`${classes.tab} tab`}>About</div> */}
          <div className={`${classes.tab} tab`}>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => window.open("/terms", "_blank")}
            >
              <a>Terms</a>
            </span>
          </div>
          {!isMobile && (
            <div className={`${classes.tab} tab`}>
              <span>
                <a>Call Us :+918069510565</a>
              </span>
            </div>
          )}
          {isMobile && (
            <div className={`${classes.tab} tab`}>
              <span style={{ cursor: "pointer" }} onClick={() => callNow()}>
                <a>Call Us</a>
              </span>
            </div>
          )}
        </div>
        <div className={classes.companyName}>
          <p style={{ margin: "0" }}>2022-23 ©️ ArtistFirst Technology Inc</p>
          <p style={{ margin: "0" }}>
            2022-23 ©️ ArtistFirst Technology India Pvt Ltd
          </p>
          <p style={{ margin: "0" }}>
            Address: B-20, 20th Floor, Tower B, Bhutani Alphathum, Sector 90,
            Noida, 201305
          </p>
        </div>
      </div>
      <Box>
        <Box className={classes.whatsApp} onClick={() => enquireNow()}>
          <Box component="img" src="/images/token/callNow.png" />
          <Typography variant="span">Enquire Now</Typography>
        </Box>
      </Box>
      {/* <Box className={classes.whatsApp}>
        <Box onClick={() => share()}>
          <Box component="img" src="/images/landing/whatsapp.svg" />
          <Typography variant="span">Reach Us</Typography>
        </Box>
      </Box> */}
    </div>
  );
}
